import { Request } from "../../hooks/Request";
import * as Yup from "yup";
import { toast } from "react-toastify";
import FormDefault from "../../components/Forms/FormDefault";
import { Circle } from "../../components/Animation";
import { validateType } from "../../utils/constant";
import { requestAuth } from "../../components/services/RequestService";
import { useDialog } from "../../contexts/DialogContext";
import { H2 } from "../../components/Text";

const FormPresence = (props) => {
	const { procedure, reload } = props;
	console.log(procedure);


	const { dialogClose } = useDialog();

	// Actualizamos el servicio de acuerdo a requerimiento:
	const { data, loading } = Request({
		urlApi: `/Procedure/${procedure.id}/datasets?fieldnames=registroDePrecinto`,
	});

	function dataIntialValues(list) {
		let aux = {};
		list?.forEach((element) => {
			aux = {
				...aux,
				[element.name]: (element.initial === "false" ? false : element.initial) || "",
			};
		});
		return aux;
	}

	function dataFields(list) {
		let aux = {};
		list?.forEach((element) => {
			if (element.validate && validateType[element.type]) {
				aux[element.name] = validateType[element.type];
			}
		});
		return aux;
	}

	async function onSubmit(values, resetForm) {
		const payload = data.map((element) => {
			return {
				Value: values[element.name] || "",
				ProcedureId: procedure.id,
				FieldId: element.id,
				name: element.name,
				url: element.url,
				type: element.type,
			};
		});

		// Enviar el guardado de los dataset
		await requestAuth("post", `/dataset`, payload)
			.then(() => {
				toast.success("Registro de precinto exitoso");
				if (reload) reload();
				dialogClose();
			})
			.catch(() => {
				toast.error("Ocurrió un error al registrar el precinto");
			});
	}

	if (!loading) {
		return <Circle />;
	}

	return (
		<div className="w-full">
			<H2 className="mb-4">
				Registro de Precinto - Trámite {procedure.internCode || procedure.id}
			</H2>
			{data && data.length > 0 ? (
				<FormDefault
					fields={data
						.sort((a, b) => a.order - b.order)
						.map((value) => ({
							...value,
							id: procedure.id,
							fieldId: value.id,
							label: value.label,
							name: value.name,
							validate: value.validate,
							placeholder: "Complete el campo",
							type: value.type,
							typeInput: value.type,
							initial: value.initial ? value.initial : null,
							urlApi: value.url
								? value.url.includes("/")
									? value.url
									: `/Dropdown/${value.url}/options`
								: "",
							urlInitial: value.url,
							value: "name",
							labelOption: "name",
						}))}
					initialValues={dataIntialValues(data)}
					validationSchema={Yup.object().shape(dataFields(data))}
					onSubmit={async (values, resetForm) => await onSubmit(values, resetForm)}
					buttonName="Registrar"
				/>
			) : (
				<div className="py-6 text-center text-gray-500">
					Este trámite no tiene el campo "registroDePrecinto" configurado.
				</div>
			)}
		</div>
	);
};

export default FormPresence;